import { render, staticRenderFns } from "./DataTableCustom.vue?vue&type=template&id=0f13fe45&"
import script from "./DataTableCustom.vue?vue&type=script&lang=ts&"
export * from "./DataTableCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports